import { api, apiFile, base_url_v1, base_url_v2 } from "./api";
import { LoginApi , ForgetApi , RegisterApi } from "./auth-api";
import { ProtectedRoute } from "./ProtectedRoute";
import { VacationApi, EditVacationApi, AddVacationApi, GetSingleVacation, GetVacationReasonsApi, VacationChangeStatusApi, DeleteVacationApi, VacationExport, AbsenceApi, AbsenceExport, OverTimeApi, OverTimeChangeStatusApi, OverTimeExport, RollCallApi, RollCallExport,RollCallFullExport, AddRollCallApi, EditRollCallApi, GetSingleRollCallApi, DeleteRollCallApi, DelayApi, DelayChangeStatusApi, DelayExport } from "./report-api";
import { DashboardApi, PlanApi, ProfileApi , NavListApi } from "./dashboard-api";
import { UsersApi,AddUserApi , ListJobApi, ListGroupJobApi, DetailForAddUserApi, DeleteUserApi, EditUserApi, SingleUserApi } from "./user-api";
import {
    JobsGroupApi, SingleJobsGroupApi, JobsGroupEditApi, AddJobsGroupApi, DeleteJobsGroupApi, JobsGroupChangeStatusApi,GetInputJobsGroupApi,AddDaynamicFieldJobsGroupApi ,GetInputEditJobsGroupApi ,
    JobsApi, SingleJobsApi, JobsEditApi, AddJobsApi, DeleteJobsApi, JobsChangeStatusApi,
    OperationApi, SingleOperationApi, OperationEditApi, AddOperationApi, DeleteOperationApi,
    VcationReasonsApi, VcationReasonsEditApi, AddVcationReasonsApi, DeleteVcationReasonsApi, SingleVcationReasonsApi,
    DelayReasonsApi, DelayReasonsEditApi, AddDelayReasonsApi, DeleteDelayReasonsApi, SingleDelayReasonsApi,
    HolidaysApi, HolidaysEditApi, AddHolidaysApi, DeleteHolidaysApi, SingleHolidaysApi, OfficialHolidaysApi,
    SchedulesApi, DeleteSchedulesApi, AddSchedulesApi, SingleSchedulesApi, EditSchedulesApi ,
    AccessLevelApi ,DeleteAccessLevelApi,GetAccessItemApi , AddAccessLevelApi , AddAccessLevelTwoApi , GetSingleAccessApi , EditAccessLevelApi ,GetSingleGroupAccessApi ,
    AdminApi ,DeleteAdminApi , AddAdminApi , GetSingleAdminApi , EditAdminApi
} from "./settings-api";

import { CompanyApi, BusinessScopesApi, JobPositionsApi, EditCompanyApi } from "./company-api";
import { LocationApi, AddLocationApi, EditLocationApi, DeleteLocationApi, SingleLocationApi, QRExport } from './location-api'
import { TicketApi, AddTicketApi } from "./ticket-api";
import {PurchaseHistoryApi , PurchaseHistoryExportApi } from "./purchaseHistory-api";
import { PlanListApi , BuyPanelApi , CheckDiscountApi} from "./plan-api";
export * from './module-api'

export {
    api,
    apiFile,
    ProtectedRoute,
    LoginApi,
    ForgetApi,
    RegisterApi,
    RollCallApi,
    AddRollCallApi,
    DeleteRollCallApi,
    EditRollCallApi,
    GetSingleRollCallApi,
    RollCallExport,
    RollCallFullExport,
    DelayApi,
    DelayChangeStatusApi,
    DelayExport,
    DashboardApi,
    OverTimeApi,
    OverTimeChangeStatusApi,
    OverTimeExport,
    AbsenceApi,
    AbsenceExport,
    VacationApi,
    VacationChangeStatusApi,
    VacationExport,
    DeleteVacationApi,
    GetVacationReasonsApi,
    AddVacationApi,
    GetSingleVacation,
    EditVacationApi,
    UsersApi,
    AddUserApi ,
    EditUserApi,
    SingleUserApi,
    DeleteUserApi,
    ListJobApi,
    ListGroupJobApi,
    DetailForAddUserApi,
    PlanApi,
    ProfileApi,
    NavListApi,
    JobsGroupApi,
    DeleteJobsGroupApi,
    JobsGroupChangeStatusApi,
    GetInputJobsGroupApi ,
    AddDaynamicFieldJobsGroupApi,
    AddJobsGroupApi,
    GetInputEditJobsGroupApi ,
    SingleJobsGroupApi,
    JobsGroupEditApi,
    JobsApi,
    SingleJobsApi,
    JobsEditApi,
    AddJobsApi,
    DeleteJobsApi,
    JobsChangeStatusApi,
    OperationApi,
    SingleOperationApi,
    OperationEditApi,
    AddOperationApi,
    DeleteOperationApi,
    VcationReasonsApi,
    VcationReasonsEditApi,
    AddVcationReasonsApi,
    DeleteVcationReasonsApi,
    SingleVcationReasonsApi,
    DelayReasonsApi,
    DelayReasonsEditApi,
    AddDelayReasonsApi,
    DeleteDelayReasonsApi,
    SingleDelayReasonsApi,
    HolidaysApi,
    HolidaysEditApi,
    AddHolidaysApi,
    DeleteHolidaysApi,
    SingleHolidaysApi,
    OfficialHolidaysApi,
    SchedulesApi,
    DeleteSchedulesApi,
    AddSchedulesApi,
    SingleSchedulesApi,
    EditSchedulesApi,
    AccessLevelApi ,
    DeleteAccessLevelApi ,
    GetAccessItemApi ,
    GetSingleGroupAccessApi ,
    AddAccessLevelApi ,
    AddAccessLevelTwoApi ,
    GetSingleAccessApi ,
    EditAccessLevelApi ,
    AdminApi ,
    GetSingleAdminApi,
    EditAdminApi ,
    DeleteAdminApi ,
    AddAdminApi ,
    BusinessScopesApi,
    JobPositionsApi,
    CompanyApi,
    EditCompanyApi,
    LocationApi,
    QRExport,
    EditLocationApi,
    DeleteLocationApi,
    SingleLocationApi,
    AddLocationApi,
    TicketApi,
    AddTicketApi,
    PurchaseHistoryApi ,
    PurchaseHistoryExportApi ,
    PlanListApi ,
    BuyPanelApi , 
    CheckDiscountApi
}